import type { MessageStoryReplyPresentationDto } from "@multi-chat/shared";
import { useTranslation } from "react-i18next";
import { cn } from "../../../lib/utils.js";
import { MessageReplyPreviewThumbnail } from "../MessageReplyPreview/MessageReplyPreviewThumbnail.js";

export function MessageStoryReplyPreview({
  presentation,
  organizationId,
  className,
}: {
  presentation: MessageStoryReplyPresentationDto;
  organizationId: number;
  className?: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const previewAttachment = presentation.previewAttachment;
  const showThumbnail =
    previewAttachment != null &&
    (previewAttachment.storageState === "STORED" ||
      previewAttachment.storageState === "PENDING_STORAGE");

  return (
    <div
      className={cn("mb-1 max-w-full", className)}
      data-testid="message-story-reply-preview"
    >
      <div className="flex min-w-0 items-stretch overflow-hidden rounded-md bg-black/[0.04]">
        <span className="w-[3px] shrink-0 self-stretch bg-accent" aria-hidden="true" />
        <div className="flex min-w-0 flex-1 items-center gap-2 px-2 py-1">
          <div className="min-w-0 flex-1">
            <p className="m-0 truncate text-[0.75rem] font-medium leading-snug text-accent">
              {t("inbox.storyReply.label")}
            </p>
          </div>
          {showThumbnail ? (
            <MessageReplyPreviewThumbnail
              organizationId={organizationId}
              attachment={{
                ...previewAttachment,
                mimeType: previewAttachment.mimeType ?? null,
              }}
              className="size-11"
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
